import facecolor from './face-color'

export default {
  'face-color': facecolor
}